module.exports = __webpack_public_path__ + "static/img/icon-en-4.a8bb6784.png";